module.exports = __webpack_public_path__ + "img/add-package.e8cf7c3b.png";